import React, {useState} from "react";
import {useFetch} from "../../../../../hooks/useFetch";
import {useStore} from "../../../../../hooks/useStore";
import {Switch, message, Card, Popconfirm} from "antd";
import moment from "moment";
import { StyledTable } from "../../courierOnboardingTab/courierSummary/courierEquipmentInformations/CourierEquipmentInformations.styled";

export const CourierPOSRecords = ({courier, courierLoading = true, reloadCourier = () => {}}) => {
    const stores = useStore();
    const [page, setPage] = useState(1);
    const [loadingTerminalId, setLoadingTerminalId] = useState(null);

    const [isCourierTerminalsLoading, courierTerminals, setCourierTerminals] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.getCourierTerminals.bind(null, {
            courierId: courier?._id,
            limit: 1000,
            page: page
        }),
        dependencies: [courier?._id],
        initialCall: Boolean(courier?._id)
    });

    const handleTerminalStatusChange = async (terminalId, isActive) => {
        try {
            setLoadingTerminalId(terminalId);
            const success = await stores.courierStore.updateCourierTerminal({
                courierId: courier._id,
                terminalId: terminalId,
                isActive: isActive
            });

            if (success) {
                message.success("Terminal durumu başarıyla güncellendi");
                setCourierTerminals(prev => ({
                    ...prev,
                    terminals: {
                        ...prev.terminals,
                        rows: prev.terminals.rows.map(row =>
                            row._id === terminalId ? {...row, isActive: isActive} : row
                        )
                    }
                }));
            }
        } catch (error) {
            message.error("Terminal durumu güncellenirken bir hata oluştu");
        } finally {
            setLoadingTerminalId(null);
        }
    };

    const formatDate = date => {
        return moment(date).format("DD.MM.YYYY HH:mm");
    };

    return (
        <Card
            title="Kurye Terminal Kayıtları"
            style={{
                width: "100%",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                borderRadius: "8px"
            }}
        >
            <StyledTable
                rowKey="_id"
                columns={[
                    {
                        title: "Serial No",
                        dataIndex: "serialNo",
                        key: "serialNo",
                        onCell: (record) => ({
                            "data-label": "Serial No"
                        })
                    },
                    {
                        title: "Terminal Id",
                        dataIndex: "terminalId",
                        key: "terminalId",
                        onCell: (record) => ({
                            "data-label": "Terminal Id"
                        })
                    },
                    {
                        title: "Provider",
                        dataIndex: "provider",
                        key: "provider",
                        onCell: (record) => ({
                            "data-label": "Provider"
                        })
                    },
                    {
                        title: "Created At",
                        dataIndex: "createdAt",
                        key: "createdAt",
                        render: text => formatDate(text),
                        onCell: (record) => ({
                            "data-label": "Created At"
                        })
                    },
                    {
                        title: "Updated At",
                        dataIndex: "updatedAt",
                        key: "updatedAt",
                        render: text => formatDate(text),
                        onCell: (record) => ({
                            "data-label": "Updated At"
                        })
                    },
                    {
                        title: "Durum",
                        dataIndex: "isActive",
                        key: "isActive",
                        align: "right",
                        render: (isActive, record) => (
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Popconfirm
                                    title="Terminal durumunu değiştirmek istediğinize emin misiniz?"
                                    okText="Evet"
                                    cancelText="Hayır"
                                    onConfirm={() => handleTerminalStatusChange(record._id, !isActive)}
                                >
                                    <Switch
                                        checked={isActive}
                                        loading={record._id === loadingTerminalId}
                                    />
                                </Popconfirm>
                            </div>
                        ),
                        onCell: (record) => ({
                            "data-label": "Durum"
                        })
                    }
                ]}
                dataSource={courierTerminals?.terminals?.rows || []}
                loading={isCourierTerminalsLoading}
                pagination={{
                    pageSize: 1000,
                    current: page,
                    total: courierTerminals?.terminals?.dataCount || 0,
                    onChange: setPage
                }}
            />
        </Card>
    );
};
